export enum ETipoMovimentoCaixa {
  Entradas = 1,
  Saidas = 2,
  Vendas = 3,
  Cancelamentos = 4,
  Devolucao = 5,
}
